module.exports = __webpack_public_path__ + "bcaa3b3e3a1e89caf9b614c7f223db30.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/flask-green.png
// module id = 2639
// module chunks = 0